export default __webpack_public_path__ + "static/media/card-profile4.8f46d7c2.jpg";